import { render } from "./Causes.vue?vue&type=template&id=5d8bc4ca&scoped=true"
import script from "./Causes.vue?vue&type=script&lang=js"
export * from "./Causes.vue?vue&type=script&lang=js"

import "./Causes.vue?vue&type=style&index=0&id=5d8bc4ca&scoped=true&lang=css"

import exportComponent from "/usr/home/demon/projects/driven/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d8bc4ca"]])

export default __exports__